import { FC, useState } from 'react';
import { Tooltip } from 'antd';
import { isNotEmpty } from '@lhb/func';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import cs from 'classnames';
import styles from './index.module.less';
import PickFolderModal from '../CollectDrawer/PickFolderModal';

/**
 * 添加收藏按钮图标
 * @description
 * @return {*}
 * @demo
 */
const AddCollectIcon: FC<{
  id?, // 数据 id
  collectStatus?, // 是否已收藏
  setCollectStatus?, // 更新收藏/取消收藏状态
  wrapperClassName?,
  iconClassName?,
  isLarge?,
  /** 收藏/取消收藏回调 */
  collectComplete?,
}> = ({
  id, // 数据 id
  collectStatus, // 是否已收藏
  setCollectStatus, // 更新收藏/取消收藏状态
  wrapperClassName,
  iconClassName,
  isLarge,
  collectComplete,
}) => {

  const [open, setOpen] = useState(false);

  return (
    <div className={styles.addCollectIcon} onClick={(e) => { e.stopPropagation(); }}>
      <Tooltip title={collectStatus ? '已收藏' : '收藏'}>
        <div
          className={cs(styles.favoriteBtnWrapper, wrapperClassName, isLarge ? styles.isLarge : '')}
          onClick={() => setOpen(true)}>
          {
            collectStatus
              ? <StarFilled className={cs('fs-12', styles.starIcon, styles.active, iconClassName)} />
              : <StarOutlined className={cs('fs-12', styles.starIcon, iconClassName)} />
          }
        </div>
      </Tooltip>

      {/* 收藏/取消收藏弹窗 */}
      <PickFolderModal
        open={open}
        selectedIds={isNotEmpty(id) ? [id] : []}
        setOpen={setOpen}
        setCollectStatus={setCollectStatus}
        callFn={collectComplete}
      />
    </div>
  );
};

export default AddCollectIcon;
